// Mui Table component replaced with DataGrid component by Dev srini on 07/08/24

import { useContext, useState } from 'react'
import { Grid, IconButton, useMediaQuery,Paper } from '@material-ui/core' // srini - 21/11/24
import { withStyles } from '@material-ui/core/styles'
import { DataGrid } from '@mui/x-data-grid'
import { format } from 'date-fns'
import { backendHosts,apiUrl } from '../../../../../ui-utils/apiConfig'
import styles from '../InCompleteKYCStyles'
// imported useContext & reducerContext - 23-07-24 - Dev Srini
import { reducerContext } from '../../../../../contextApi\'s/contextApi\'s'
import handleStartCall from "../../../../../helpers/handleStartCall"
// srini - 21/11/24
import CallIcon from '@mui/icons-material/Call'
import EditIcon from '@mui/icons-material/Edit'
import DialogBox from '../../../../Dialog Box/DialogBox'
import axios from 'axios'

const TableDisplay = ({
    classes,
    inCompleteKyc,
    handleEditDetails,
    filterModel,
    handleNewFilter
}) => {



    const { state, dispatch } = useContext(reducerContext)
    const screen1800px = useMediaQuery("(max-width:1800px)") //dev-trupti on 23-10-2024
    // Dailog box bug fixed - srini - 15/04/24 
    const [dailBoxOpen, setDailBoxOpen] = useState(false)
    const [selectedCustNumber, setSelectedCustNumber] = useState(null)
    const username = localStorage.getItem('username')
    const userId = JSON.parse(localStorage.getItem('sipRegData'))?.sip_id 
    const handleClickOpen = (phNum) => {
        setDailBoxOpen(true)
        setSelectedCustNumber(phNum)
    }

    const handleClose = () => {
        setDailBoxOpen(false)
    }

    const formatStage = (value) => {
        switch (value) {
            case 'Bank_verification':
                return 'Bank Verification';
            case 'REG_START':
                return 'Registration Start';
            case 'aadhaar verified':
                return 'Aadhaar Verified';
            case 'digilocker':
                return 'Digilocker';
            case 'OTP_SENT':
                return 'OTP Sent';
            case 'preferences':
                return 'Preferences';
            case 'qualification':
                return 'Qualification';
            case 'payment':
                return 'Payment';
            case 'docupload':
                return 'Document Upload';
            case 'liveliness':
                return 'Liveliness';
            case 'digilocker_adhar':
                return 'Digilocker Aadhaar';
            case 'Nominee':
                return 'Nominee';
            case 'DIS':
                return 'DIS Status';
            case 'completed':
                return 'Completed';
            case 'pis_yes': //dev-trupti on 15-01-2025
                return 'PIS Yes';
            case 'pis_no':
                return 'PIS No';
            case 'nri':
                return 'NRI Upload'
            default:
                return value; // Fallback if no match
        }
    };
    const columns = [
        // Srini - 12/11/24
        {
            field: 'action',
            headerName: 'Action',
            headerAlign: 'center',
            renderCell: (params) => (
                <div style={{ display: 'flex', alignItems: 'center',justifyContent:'center' }}>
                    {/* <IconButton
                        key={`call-${params.row.id}`}
                        // srini - 21/11/24
                        onClick={() => handleClickOpen(params.row.phone)} className={classes.cllIcnClr}>
                        <CallIcon style={{ fontSize: '18px' }} />
                    </IconButton> */}
                    <IconButton
                        key={`edit-${params.row.user_id}`}
                        className={classes.edtIcnClr} // srini - 21/11/24
                        onClick={() =>handleEditDetails(params.row.user_id )}>
                        <EditIcon style={{ fontSize: '18px' }} />
                    </IconButton>
                    {/* Dailog box bug fixed - srini - 15/04/24 */}
                    {/* <DialogBox
                        open={dailBoxOpen}
                        handleClose={handleClose}
                        customerNumber={selectedCustNumber}
                        dispatch={dispatch}
                        handleStartCall={handleStartCall}
                    /> */}
                </div>
            ),
            width: 150, //dev-trupti on 19-11-2024
        },
        {
            field: 'createdAt',
            headerName: 'ACOP Start Date',
            width: screen1800px? 95 : 150, //dev-trupti on 19-11-2024
            valueFormatter: (params) => {
                return format(new Date(params), 'yyyy-MM-dd HH:mm');
            },
        },

        
        // {
        //     field: 'accountno',
        //     headerName: 'Account',
        //     width: 75, //dev-trupti on 19-11-2024
        //     renderCell: (params) => (
        //         <span>{params.row.accountno_prefix}{params.row.accountno}</span>
        //     ),
        //     align: 'center'
        // },
        {
            field: 'updatedAt',
            headerName: 'Last Activity',
            width: screen1800px? 95 : 140, //dev-trupti on 19-11-2024
            valueFormatter: (params) => {
                return format(new Date(params), 'yyyy-MM-dd HH:mm');
            },
        },

        {
            field: 'client_id',
            headerName: 'Account',
            width: screen1800px ? 100 : 100, //dev-trupti on 19-11-2024
        },
        {
            field: 'name',
            headerName: 'Name',
            width: screen1800px? 100 : 180, //dev-trupti on 19-11-2024
        },
        {
            field: 'email',
            headerName: 'Email',
            width: screen1800px? 190 : 240, //dev-trupti on 19-11-2024
        },
        {
            field: 'mobile',
            headerName: 'Phone',
            width: screen1800px? 92 : 120, //dev-trupti on 19-11-2024
        },
        //Added by dev-trupti on 19-11-2024
        // {    
        //     field: 'city',
        //     headerName: 'City',
        //     width: screen1800px? 80 : 100, //dev-trupti on 19-11-2024
        //     align: 'left'
        // },
        // {
        //     field: 'state',
        //     headerName: 'State',
        //     width:  screen1800px? 85 : 100, //dev-trupti on 19-11-2024
        //     align: 'center'
        // },
        {
            field: 'kyc_status',
            headerName: 'Completed Stage',
            width: screen1800px? 120 : 140, //dev-trupti on 19-11-2024
            // valueFormatter: (params) => formatStage(params),
        },
        // {
        //     field: 'backoffice',
        //     headerName: screen1800px ? "BO" : "Pushed BO", //dev-trupti on 19-11-2024
        //     width: screen1800px? 20 : 100, //dev-trupti on 19-11-2024
        //     valueFormatter: (params) => params === 1 ? 'Yes' : 'No',
        //     align: 'center'
        // },
        //Added refcode dev-trupti 22-10-2024
        {
            field: 'referral_code',
            headerName: 'Refcode',
            width: screen1800px? 50 : 100, //dev-trupti on 19-11-2024
            align: 'center',
            valueFormatter:(params) => {
                return params && params !== "undefined" ? params : ""
            } // srini - 21/11/24
        },
        {
            field: 'kyc_type',   // Karthik on 10-01-2025
            headerName: "kyc_type",
            width: screen1800px ? 50 : 100,
            align: 'center',
            valueFormatter: (params) => {
                return params && params !== "undefined" ? params : ""
            }
        },
        {
            field: 'resume',
            headerName: "Resume",
            width: 80,
            align: 'center',
            renderCell: (params) => {

                const values = params.row
                if (!values?.email || !values?.mobile) {
                    return (
                        <span style={{ color: "#888", cursor: "not-allowed", opacity: 0.6 }}>
                            Re-login
                        </span>
                    )
                }

                const baseHostName = window.location.hostname
                let baseUrl

                if (baseHostName.includes("staging") || baseHostName.includes("localhost")) {
                    baseUrl = 'https://kyc-frontend-staging.tradeboss.co'
                } else {
                    baseUrl = 'https://kyc.tradeboss.co'
                }

                const handleClick = async (e) => {

                    const payload = {
                        data: {
                            user_id: params.row.user_id,
                            crmUserName: username,
                            crmUserId: userId,
                            mobile: values?.mobile
                        }
                    }

                    try {
                        const response = await axios.post(`${backendHosts.ADMIN}${apiUrl.relogin}`, payload)
                        console.log("Relogin Response", response)
                    }
                    catch (err) {
                        console.log("Somthing went wrong in relogin Api", err)
                    }

                    console.log(payload)
                    console.log("Relogin URL", `${baseUrl}?resume=${values?.mobile}`)

                    e.stopPropagation();
                    const url = `${baseUrl}?resume=${values?.mobile}`;
                    console.log("Opening URL:", url);
                    window.open(url, "_blank", "noopener,noreferrer");

                }

                return (
                    <a
                        onClick={(e)=>{handleClick(e)}}
                        style={{ color: "#edd682 ", textDecoration: "underline",cursor:"pointer" }}
                    >
                        Re-login
                    </a>
                );
            }
        }
        // {  
        //     field: 'dramount',   // Karthik on 10-01-2025
        //     headerName: screen1800px ? "DRAMT" : "DR Amount",
        //     width: screen1800px ? 50 : 100,
        //     align: 'center',
        //     valueFormatter: (params) => {
        //         return params && params !== "undefined" ? params : ""
        //     }
        // }
    ]

    const rows = inCompleteKyc

    return (
        <Paper className={classes.horizantalTablayout}>
            <DataGrid
                rows={rows}
                columns={columns}
                filterModel={filterModel}
                onFilterModelChange={handleNewFilter}
                className={classes.customDataGrid}
                sx={{
                    '--DataGrid-containerBackground': '#131E2E',
                    '--DataGrid-rowBorderColor': '#000',
                    'border': 0,
                    width:'100% !important', //dev-trupti on 23-10-2024

                }}
                getRowId={(row) => row.user_id}
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: 15 },
                    },
                }}

                pageSizeOptions={[15, 25, 50]}
            />
        </Paper>
    )
}

export default withStyles(styles)(TableDisplay)